import { ProFormText } from '@ant-design/pro-components';
export default ProFormText;
